import { CONFIRM_SALE_ALLOWED_STATUSES, VIEW_TIMELINE_STATUSES } from '../../../documentCapture/DocumentCapture.helpers';

export const statusesToHideValueTracker = [
  CONFIRM_SALE_ALLOWED_STATUSES.SOLD_AWAITING,
  CONFIRM_SALE_ALLOWED_STATUSES.SOLD_CONFIRMED,
  CONFIRM_SALE_ALLOWED_STATUSES.SOLD_DOCUMENTS_REVIEWED,
  CONFIRM_SALE_ALLOWED_STATUSES.SOLD_INVOICE_RAISED,
  CONFIRM_SALE_ALLOWED_STATUSES.SOLD_INVOICE_PAID,
  VIEW_TIMELINE_STATUSES.FOR_SALE,
  VIEW_TIMELINE_STATUSES.FULL_DETAILS_CONTACTED,
  VIEW_TIMELINE_STATUSES.FULL_DETAILS_WAIT,
  VIEW_TIMELINE_STATUSES.QA_FAILED,
  VIEW_TIMELINE_STATUSES.QA_ON_HOLD,
  VIEW_TIMELINE_STATUSES.QA_READY,
  VIEW_TIMELINE_STATUSES.READY_FOR_SALE,
  VIEW_TIMELINE_STATUSES.SALE_ACTIVE,
  VIEW_TIMELINE_STATUSES.UNSOLD_BELOW_RESERVE_BID,
  VIEW_TIMELINE_STATUSES.UNSOLD_NO_BIDS,
  VIEW_TIMELINE_STATUSES.UNDER_OFFER,
  VIEW_TIMELINE_STATUSES.UNDER_OFFER,
  VIEW_TIMELINE_STATUSES.CUSTOMER_KEEP_CAR,
  VIEW_TIMELINE_STATUSES.CUSTOMER_LOST,
  VIEW_TIMELINE_STATUSES.CAR_GONE,
  VIEW_TIMELINE_STATUSES.TOO_EXPENSIVE,
  VIEW_TIMELINE_STATUSES.UNSELLABLE,
  VIEW_TIMELINE_STATUSES.WRITE_OFF,
] as string[];
